import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { CommonModule, NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, SlicePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseAlertComponent } from '@fuse/components/alert';
import { FuseCardComponent } from '@fuse/components/card';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollDispatcher, CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Util } from 'app/models/util';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { RagService } from 'app/services/rag.service';
import { ToastrService } from 'ngx-toastr';
import { CopilotSettings } from 'app/models/copilot.model';

@Component({
  selector: 'app-copilot-settings-wc',
  standalone: true,
  imports: [NgFor,
    CommonModule,
    NgClass,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    FuseAlertComponent,
    MatSidenavModule,
    SlicePipe,
    TranslateModule,
    FuseCardComponent,
    FuseAlertComponent,
],
  templateUrl: './copilot-settings-wc.component.html',
  styleUrl: './copilot-settings-wc.component.scss'
})
export class CopilotSettingsWcComponent {

  showScrollToTop: boolean = false;
  scrollSubscription: Subscription = new Subscription();
  focusList: any[] = [];
  selectedPanel: string = 'assistants';
  @ViewChild(CdkScrollable, { static: true }) scrollable: CdkScrollable;
  @ViewChild('drawer') drawer: MatDrawer;
  drawerMode: 'over' | 'side' = 'side';
  drawerOpened: boolean = true;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  isLoading: boolean = false;
  settings: CopilotSettings= new CopilotSettings();
  featureColumns: string[] = ['name', 'enabled'];

  constructor(
    public util: Util,
    public sanitizer: DomSanitizer,
    private _changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private scrollDispatcher: ScrollDispatcher,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private rag_service: RagService,
    private toast_service: ToastrService,
) {
    this.focusList = [
      {
        id: 'assistants',
        icon: 'heroicons_solid:cpu-chip',
        title: 'Assistants',
        description: 'Manage AI assistants and their configurations',
      },
      {
        id: 'agents',
        icon: 'heroicons_solid:user-group',
        title: 'Agents',
        description: 'Manage AI agents and their configurations',
      }

    ];

}

  ngOnInit(): void {
     //Configure scroll
     this.scrollSubscription = this.scrollDispatcher
     .scrolled()
     .subscribe((event: CdkScrollable) => {
         const scrollTop = event.getElementRef().nativeElement.scrollTop;
         this.showScrollToTop = scrollTop > 100;
         this._changeDetectorRef.detectChanges();
     });

      // Subscribe to media changes
      this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
          if (matchingAliases.includes('lg')) {
              this.drawerMode = 'side';
              this.drawerOpened = true;
          } else {
              this.drawerMode = 'over';
              this.drawerOpened = false;
          }
          // Mark for check
          this._changeDetectorRef.markForCheck();
      });

      this.loadSettings();
  }

  scrollToTop(): void {
    this.scrollable.scrollTo({ top: 0, behavior: 'smooth' });
}

    /**
     * Track by function for ngFor loops
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
      return item.id || index;
  }

  save() {
    this.isLoading = true;
    const activeAssistantsIds = this.settings.assistants.filter(x => x.enabled).map(x => x.id);
    const activeAgentsIds = this.settings.agents.filter(x => x.enabled).map(x => x.id);
    const payload = {
      assistantIds: activeAssistantsIds,
      agentIds: activeAgentsIds,
    }
    this.rag_service.saveSettings(payload).then(() => {
      this.toast_service.success('Copilot settings have been saved successfully.', 'Success');
    }
    ).catch(err => {
      console.error('Error saving RAG settings', err);
    }).finally(()=>{
      this.isLoading = false
    })
  }

  loadSettings(){
    this.rag_service.getSettings().then((response) => {
      this.settings = this.rag_service.getData(response);
      if (this.settings) {
        // this.copilotEnabled = this.settings.ragEnabled;
      }
    }
    ).catch(err => {
      console.error('Error fetching RAG settings', err);
    }
    );
  }

      /**
     * Navigate to the panel
     *
     * @param panel
     */
      goToPanel(panel: any): void {
        this.selectedPanel = panel;
        if (this.drawerMode === 'over') {
            this.drawer.close();
        }
    }

}
